import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { Modal, Button } from 'react-bootstrap';
import moment from 'moment';

import { getProfile } from '../../redux/profile/profile_actions';
import { has_value } from '../../utils/utility';

const EMPTY_PLACEHOLDER = '-';

const formatDisplayValue = (value) => {
  if (!has_value(value)) {
    return EMPTY_PLACEHOLDER;
  }
  if (typeof value === 'string' && value.trim() === '') {
    return EMPTY_PLACEHOLDER;
  }
  return String(value);
};

const formatDate = (value) => {
  if (!has_value(value)) {
    return EMPTY_PLACEHOLDER;
  }
  const m = moment(value);
  return m.isValid() ? m.format('DD/MM/YYYY') : EMPTY_PLACEHOLDER;
};

const formatRoles = (roles, t) => {
  if (!roles || roles.length === 0) {
    return EMPTY_PLACEHOLDER;
  }
  return roles
    .map((role) => {
      const name = role && role.name ? role.name : '';
      if (!name) {
        return EMPTY_PLACEHOLDER;
      }
      const key = name.toLowerCase();
      const translated = t(key);
      return translated !== key ? translated : name;
    })
    .join(', ');
};

class ProfileModal extends React.Component {
  componentDidUpdate(prevProps) {
    if (this.props.show && !prevProps.show) {
      this.props.getProfile();
    }
  }

  renderField(label, value) {
    return (
      <div className="profile-modal-field" style={{ marginBottom: 12 }}>
        <div style={{ fontSize: 12, color: '#888', marginBottom: 4 }}>{label}</div>
        <div style={{ fontSize: 15, color: '#333', wordBreak: 'break-word' }}>{value}</div>
      </div>
    );
  }

  render() {
    const { t, show, onHide, profile, isLoading, errorMessage } = this.props;
    const userProfile = profile && profile.user_profile ? profile.user_profile : {};

    const fullName = [profile && profile.first_name, profile && profile.last_name]
      .filter(v => has_value(v) && String(v).trim() !== '')
      .join(' ');

    const errorText = typeof errorMessage === 'string'
      ? errorMessage
      : errorMessage && errorMessage.detail
        ? errorMessage.detail
        : t('not found');

    return (
      <Modal
        show={show}
        onHide={onHide}
        container={this}
        aria-labelledby="profile-modal-title"
      >
        <Modal.Header closeButton>
          <Modal.Title id="profile-modal-title">{t('profile')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {isLoading ? (
            <div style={{ display: 'flex', justifyContent: 'center', padding: 24 }}>
              <i className="fas fa-spinner fa-spin fa-2x" style={{ color: '#bbb' }} />
            </div>
          ) : errorMessage ? (
            <div style={{ color: '#a94442' }}>{errorText}</div>
          ) : !profile ? (
            <div style={{ color: '#888' }}>{t('not found')}</div>
          ) : (
            <div>
              {this.renderField(t('username'), formatDisplayValue(profile.username))}
              {this.renderField(t('name'), formatDisplayValue(fullName || null))}
              {this.renderField(t('email'), formatDisplayValue(profile.email))}
              {this.renderField(t('role'), formatRoles(profile.role, t))}
              {this.renderField(t('license no'), formatDisplayValue(userProfile.license))}
              {this.renderField(t('certification date'), formatDate(userProfile.certification_date))}
              {this.renderField(t('renewal date'), formatDate(userProfile.renewal_date))}
              {this.renderField(t('expiry date'), formatDate(userProfile.expiry_date))}
              {this.renderField(t('license period days'), formatDisplayValue(userProfile.license_period_days))}
              {this.renderField(t('expiry display'), formatDisplayValue(userProfile.expiry_display))}
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={onHide}>{t('close')}</Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = state => ({
  isLoading: state.profile.isLoading,
  profile: state.profile.profile,
  errorMessage: state.profile.errorMessage,
});

const mapDispatchToProps = dispatch => ({
  getProfile: () => dispatch(getProfile()),
});

export default translate('translations')(
  connect(mapStateToProps, mapDispatchToProps)(ProfileModal),
);



// WEBPACK FOOTER //
// ./src/modal/account/ProfileModal.js